<template>
  <div class="new-product body">
    <el-container>
      <!-- <ExpenseAside /> -->

      <el-main>
        <div class="mb-4">
          <h4>إضافة مصروف جديد</h4>
        </div>

        <div class="row">
          <div class="col-md-6 mb-2">
            <div>
              <h6 class="mb-2">اسم المشروع</h6>
              <el-select
                style="width: 100%"
                placeholder=". "
                v-model="form.project_id"
              >
                <el-option
                  v-for="item in projects"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-6 mb-2">
            <div>
              <label for="search" class="d-block">وصف المصروف </label>

              <el-select
                searchable
                @focus="index = 0"
                class="mt-2 col-12 p-0"
                v-model="form.category_id"
                placeholder=". "
                @change="focusNext"
              >
                <el-option
                  v-for="item in categories"
                  :key="item.id"
                  :label="item.description"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-md-6 mb-2">
            <div>
              <label for="search">المبلغ  ({{convertNumber(form.cost)}})</label>
              <el-input
                class="mt-2 input1"
                id="cost"
                type="number"
                @focus="$event.target.select()"
                v-model="form.cost"
                controls-position="right"
                @keyup.enter.native="focusNext"
              ></el-input>
            </div>
          </div>

          <div class="col-md-6">
            <div>
              <label for="">المُستلم </label>
              <el-input
                class="mt-2 input2"
                @focus="$event.target.select()"
                v-model="form.for_who"
                @keyup.enter.native="focusNext"
              ></el-input>
            </div>
          </div>

          <div class="col-md-6 mb-2">
            <div>
              <label for="">تعليق </label>
              <el-input
                class="mt-2 input3"
                @focus="$event.target.select()"
                v-model="form.comment"
                @keyup.enter.native="focusNext"
              ></el-input>
            </div>
          </div>

          <div class="col-md-12">
            <div>
              <el-button class="mt-2" type="warning" @click="addNewExpense()">
                تسجيل</el-button
              >
            </div>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
// import ExpenseAside from "@/components/ExpenseAside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  name: "NewCustomer",
  // components: { ExpenseAside },
  data() {
    return {
      index: 0,
      false: false,
      categories: [],
      projects: [],

      form: {
        comment: "",
        cost: "",
        for_who: "",
        category_id: null,
        project_id: null,
        inventory_id: 1,
      },
    };
  },
  created() {
    this.getCategories();
    this.getProjects();
  },
  mounted() {},

  methods: {
    convertNumber(val) {
      if (val > 0) {
        return Number(val).toLocaleString("en-US");
      } else {
        return "";
      }
    },
    getProjects() {
      const loading = this.$loading({
        lock: true,
        text: false,
        spinner: "el-icon-loading",
        background: "rgba(255,255,255,.7)",
        customClass: "fullscreen-loading",
      });
      axiosApi
        .get("/projects")
        .then((res) => {
          this.projects = res.data;
        })
        .finally(() => loading.close());
    },
    focusNext() {
      if (this.index < 3) {
        this.index += 1;
      } else {
        this.index = 1;
      }

      let input = ".input" + this.index + " input";
      console.log(input);
      setTimeout(() => {
        document.querySelector(input).focus();
      }, 100);
    },

    getCategories() {
      axiosApi
        .get("categories")
        .then((res) => {
          this.categories = res.data;
        })
        .catch((error) => console.log(error))
        .finally(() => {});
    },

    addNewExpense() {
      axiosApi
        .post("expenses", this.form)
        .then((res) => {
          console.log("tttt",res)
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حفظ بيانات المصروف بنجاح",
            type: "success",
            duration: 1500,
          });
          setTimeout(() => {
          this.$router.go(0)
            
          }, 1500);
       
        })
        .catch((err) => {
          console.log("---- error ----- ",err);
          if (err.response.status == 403) {
            this.$notify({
              title: "عفوا المبلغ المطلوب غير متوفر ",
              message: `المتوفر الان ${err.response.data.balance.toLocaleString('en-US')}`,
              type: "error",
              duration: 1500,
            });
          } else {
            this.$notify({
              title: "حدث خطأ",
              message: "عفوا لم تتم العملية ",
              type: "error",
              duration: 1500,
            });
          }
        });
    },
  },
};
</script>